import React from "react";

export function SignalBadge({ score, size = "md" }) {
  if (score == null) return null;
  const dims = size === "sm" ? "w-11 h-11 text-sm" : size === "lg" ? "w-20 h-20 text-2xl" : "w-14 h-14 text-lg";
  const strong = score >= 8;
  return (
    <div
      data-testid="signal-score"
      title={`OnchainLyfe Signal ${score}/10`}
      className={`relative flex flex-col items-center justify-center rounded-full ${dims} font-mono-cl font-bold shrink-0`}
      style={{
        border: `2px solid ${strong ? "#ccff00" : "rgba(204,255,0,0.4)"}`,
        boxShadow: strong ? "0 0 18px rgba(204,255,0,0.35)" : "none",
        color: strong ? "#ccff00" : "#d4d4d8",
      }}
    >
      <span className="leading-none">{Number(score).toFixed(1)}</span>
      <span className="text-[8px] tracking-[0.2em] text-zinc-500 mt-0.5">SIGNAL</span>
    </div>
  );
}
